import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { CurrencyNumberPipe } from './currency-number.pipe';

const symbol = {
  en: {
    USD: (v) => `$${v} (USD)`,
    THB: (v) => `฿${v} (THB)`,
    GBP: (v) => `£${v} (GBP)`,
    KRW: (v) => `₩${v} (KRW)`,
    SBD: (v) => `$${v} (SBD)`,
    STEEM: (v) => `${v} (STEEM)`,
  },
  ko: {
    USD: (v) => `$${v} (USD)`,
    THB: (v) => `฿${v} (THB)`,
    GBP: (v) => `£${v} (GBP)`,
    KRW: (v) => `${v} 원`,
    SBD: (v) => `$${v} (SBD)`,
    STEEM: (v) => `${v} (STEEM)`,
  },
};

@Pipe({
  name: 'price',
})
export class PricePipe implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private currencyNumberPipe: CurrencyNumberPipe
  ) {}

  transform(value: any, currency: string, numWrapClass?: string): any {
    const lang = this.translate.currentLang === 'ko' ? 'ko' : 'en';

    if (symbol[lang][currency]) {
      let number = this.currencyNumberPipe.transform(value, currency);

      if (numWrapClass) {
        number = `<span class="${numWrapClass}">${number}</span>`;
      }

      return symbol[lang][currency](number);
    }

    return value;
  }
}
